module.exports = __webpack_public_path__ + "static/media/linkedin.69e5ce87.svg";